import { useEffect, useRef, useState } from "react";

// 쪽 위 QR 자리에 심는 스피커(2026-10-18 대표). 종이책의 QR 처럼 누르면 본문을 처음부터 들려준다.
// 속도 조절은 두지 않는다. 다른 음원 단추(PassageAudioButton)와 같은 알림으로 한 번에 하나만 울린다.
const PLAY_EVENT = "passage-audio-play";

// 단추 없이 소리 하나를 튼다(파닉스 책 소리 보기 ①②③④ 를 고를 때). 다른 스피커와 한 번에 하나만 울린다.
let optionAudio = null;
export const playOptionSound = (url) => {
  if (!url) return;
  if (optionAudio) optionAudio.pause();
  optionAudio = new Audio(url);
  window.dispatchEvent(new CustomEvent(PLAY_EVENT, { detail: optionAudio }));
  optionAudio.play().catch(() => {});
};

// 단어장(지인에듀 7판) 낱말 · 예문 자리는 음원 없이 글만 온다. 브라우저 TTS 로 읽는다.
const speakText = (text, onEnd) => {
  if (!window.speechSynthesis || !text) {
    onEnd();
    return;
  }
  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = "en-US";
  utterance.rate = 0.9;
  utterance.onend = onEnd;
  utterance.onerror = onEnd;
  window.speechSynthesis.speak(utterance);
};

// 파닉스 책(2026-10-19)의 쪽 QR(Listen & Check · Speak Up)은 음원 하나가 아니라 그 쪽 음원 목록(playlist)이다. 차례로 튼다.
const SpeakerButton = ({ audioUrl, playlist, speechText, style, className = "" }) => {
  const audioRef = useRef(null);
  const trackList = playlist && playlist.length ? playlist : audioUrl ? [audioUrl] : [];
  const [trackIndex, setTrackIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  // 음원을 못 열면(지인에듀 이용권이 끝나면 404) 숨는다
  const [isBroken, setIsBroken] = useState(false);

  useEffect(() => {
    const pauseIfOther = (event) => {
      if (optionAudio && event.detail !== optionAudio) optionAudio.pause();
      if (audioRef.current && event.detail !== audioRef.current) audioRef.current.pause();
      // 음원이 울리기 시작하면 읽어 주던 TTS(단어장)는 멈춘다
      if (event.detail && window.speechSynthesis) window.speechSynthesis.cancel();
    };
    window.addEventListener(PLAY_EVENT, pauseIfOther);
    const audio = audioRef.current;
    return () => {
      window.removeEventListener(PLAY_EVENT, pauseIfOther);
      if (audio) audio.pause();
    };
  }, []);

  if (!trackList.length && speechText) {
    return (
      <button
        type="button"
        className={`page-speaker${isPlaying ? " is-playing" : ""}${className ? ` ${className}` : ""}`}
        style={style}
        onClick={(event) => {
          event.stopPropagation();
          window.dispatchEvent(new CustomEvent(PLAY_EVENT, { detail: null }));
          setIsPlaying(true);
          speakText(speechText, () => setIsPlaying(false));
        }}
        aria-label="듣기"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M4 9h4l5-4v14l-5-4H4z" />
          <path d="M16 9a4 4 0 0 1 0 6M19 6a8 8 0 0 1 0 12" />
        </svg>
      </button>
    );
  }
  if (!trackList.length || isBroken) return null;

  const toggle = (event) => {
    event.stopPropagation();
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) audio.play().catch(() => setIsPlaying(false));
    else {
      audio.pause();
      setTrackIndex(0);
    }
  };

  return (
    <button
      type="button"
      className={`page-speaker${isPlaying ? " is-playing" : ""}${className ? ` ${className}` : ""}`}
      style={style}
      onClick={toggle}
      aria-label={isPlaying ? "멈추기" : "본문 듣기"}
    >
      <audio
        ref={audioRef}
        src={trackList[trackIndex] || trackList[0]}
        preload="none"
        onPlay={() => {
          setIsPlaying(true);
          window.dispatchEvent(new CustomEvent(PLAY_EVENT, { detail: audioRef.current }));
        }}
        onPause={() => setIsPlaying(false)}
        onEnded={() => {
          if (trackIndex < trackList.length - 1) {
            setTrackIndex(trackIndex + 1);
            // 다음 곡 주소가 바뀐 뒤에 튼다
            setTimeout(() => audioRef.current && audioRef.current.play().catch(() => setIsPlaying(false)), 0);
            return;
          }
          setTrackIndex(0);
          setIsPlaying(false);
        }}
        onError={() => setIsBroken(true)}
      />
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {isPlaying ? (
          <path d="M9 6v12M15 6v12" />
        ) : (
          <>
            <path d="M4 9h4l5-4v14l-5-4H4z" />
            <path d="M16 9a4 4 0 0 1 0 6M19 6a8 8 0 0 1 0 12" />
          </>
        )}
      </svg>
    </button>
  );
};

export default SpeakerButton;
